import {Stack, Typography, useTheme} from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import backgroundImage from "../../resources/images/pizza_landscape.jpg";
import logo from "../../resources/images/logo-background.png"
import {Link} from 'react-scroll';
import LanguageSelector from "../_atoms/LanguageSelector";
import {useTranslations} from "../../store/LanguageProvider";

const HeroImage = (props) => {
    const { palette } = useTheme();
    const { translations, currentLang } = useTranslations();

    return <>
        <Stack
            justifyContent='center'
            alignItems='center'
            direction='column'
            sx={{
                width: '100vw',
                height: '100dvh',
                backgroundImage: `url(${backgroundImage})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover'
        }}>
            <img src={logo} alt="La bruschetta logo" style={{
                width: '70vw',
                maxWidth: 300,
                height: 'auto',
            }}/>
                <Stack sx={{
                    position: 'absolute',
                    top: '1rem',
                    right: '1rem'
                }}>
                    <LanguageSelector />
                </Stack>
                <Stack alignItems='center' sx={{
                    position: 'absolute',
                    bottom: 0,
                    pb: 3,
                    opacity: .8
                }}>
                    <Typography variant='h4' textAlign='center' fontSize='1rem' color={palette.brLight.main}>
                        <Link to='menu' smooth={true}>
                            { props.title ? props.title : translations.scroll_for_menu}
                        </Link>
                    </Typography>
                    {!props.title &&
                        <Link to='menu' smooth={true}>
                            <KeyboardArrowDownIcon sx={{
                                fontSize: 30,
                                color: palette.brLight.main,
                                animationName: 'bounce',
                                animationDuration: '1s',
                                animationDirection: 'alternate',
                                animationTimingFunction: 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
                                animationIterationCount: 'infinite'
                            }} />
                        </Link>}
                </Stack>
        </Stack>
    </>
}

export default HeroImage;